module.exports = __webpack_public_path__ + "static/media/images_section_img5.28e4bb62.png";